export const useWebsiteSwitch = () => {
	const { refresh: refreshUserWebsites } = useUserWebsitesStore();
	const { fetch: refreshUser } = useUserSession();
	const activeWebsite = useState('activeWebsite');

	const isLoading = ref(false);

	const switchToWebsite = async (websiteId: string) => {
		if (isLoading.value) {
			return;
		}

		isLoading.value = true;
		try {
			await $fetch(`/api/data/user/website/${websiteId}`, { method: 'POST' });
			await refreshUser();
			await refreshUserWebsites();
			activeWebsite.value = websiteId;
		} catch {
			toastError('Failed to switch website', 'Please try again');
		} finally {
			isLoading.value = false;
		}
	};

	return {
		switchToWebsite,
		isLoading: readonly(isLoading)
	};
};
